import { createStore } from '@xstate/store';

export const pageStore = createStore({
  context: {
    page: '',
    id: '',
  },
  on: {
    updatePage: (context, page) => ({ ...context, ...page }),
  },
});
